import msg from "components/string-table";
import { Colors, Icon, SwingHeroScoreProgress } from "main";
import { generateSwingSupportURL } from "swing-utils";

import styles from "./SwingHeroEligible.module.css";

type SwingHeroEligibleProps = {
  score: number;
  isSwingHero: boolean;
  isHourly: boolean;
  onClick?: () => void;
};

export function SwingHeroEligible(props: SwingHeroEligibleProps) {
  const { score, onClick, isSwingHero, isHourly } = props;

  const status = isSwingHero
    ? `${msg("SUB_PROFILE_CONTACT_SWING")} ${msg("SUB_PROFILE_CONTACT_HERO")}`
    : msg("SWING_HERO_SWING_SUB");

  return (
    <div className={styles.container}>
      <p className={styles.title}>{msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_TITLE")}</p>
      <p className={styles.subTitle}>
        {msg("SWING_HERO_ELIGIBLE_SUB_TEXT_START", { isSwingHero })}{" "}
        <strong>{msg("SWING_HERO_ELIGIBLE_SUB_TEXT_BOLD")}</strong>{" "}
        {msg("SWING_HERO_ELIGIBLE_SUB_TEXT_END", { isSwingHero })}
      </p>
      <div className={styles.statusContainer}>
        <p className={styles.statusTitle}>{msg("SWING_HERO_YOUR_STATUS")}</p>
        <p className={styles.status}>{status}</p>
      </div>
      <div className={styles.scoreContainer}>
        <SwingHeroScoreProgress score={score} />
        <p className={styles.scoreSubText}>{msg("SWING_HERO_ELIGIBLE_STATUS_SUB_TEXT")}</p>
      </div>
      <List
        title={
          isSwingHero
            ? msg("SWING_HERO_ELIGIBLE_HERO_SCORE_LIST_TITLE")
            : msg("SWING_HERO_ELIGIBLE_SCORE_LIST_TITLE")
        }
        type="score"
      />
      <List
        title={
          isSwingHero
            ? msg("SWING_HERO_ELIGIBLE_HERO_PERKS_LIST_TITLE")
            : msg("SWING_HERO_ELIGIBLE_PERKS_LIST_TITLE")
        }
        type="perks"
      />
      {/* TODO: To update with design system button when ready */}
      <button className={styles.button} onClick={onClick}>
        {msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_BUTTON_LABEL")}
      </button>
      <p style={{ margin: "12px 0", textAlign: "center" }}>
        {`${msg("SWING_HERO_LEARN_MORE_ABOUT")} `}
        <a
          href={generateSwingSupportURL(
            isHourly
              ? msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_SUPPORT_ARTICLE_LINK_W2")
              : msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_SUPPORT_ARTICLE_LINK_1099"),
          )}
          target="_blank"
          rel="noreferrer"
        >
          {msg("SWING_HEROES")}
        </a>
        .
      </p>
    </div>
  );
}

const listMessages = {
  score: {
    FIRST: msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_EARN_HIGH_SCORE_LIST_FIRST_ITEM"),
    SECOND: msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_EARN_HIGH_SCORE_LIST_SECOND_ITEM"),
    THIRD: msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_EARN_HIGH_SCORE_LIST_THIRD_ITEM"),
  },
  perks: {
    FIRST: msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_PERKS_LIST_FIRST_ITEM"),
    SECOND: msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_PERKS_LIST_SECOND_ITEM"),
    THIRD: msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_PERKS_LIST_THIRD_ITEM"),
  },
};

const listIconConfig = {
  score: { iconName: "Check Circle" as const, color: Colors.green500 },
  perks: { iconName: "Star Circle" as const, color: undefined },
};

type ListProps = {
  title: string;
  type: keyof typeof listMessages;
};

function List(props: ListProps) {
  const { title, type } = props;
  const { iconName, color } = listIconConfig[type];

  const renderListItem = (text: string, idx: number) => (
    <li key={`${type}-${idx}`} className={styles.listItem}>
      <div className={styles.listIcon}>
        <Icon name={iconName} {...(color && { color })} />
      </div>
      {text}
    </li>
  );

  return (
    <div style={{ alignSelf: "flex-start" }}>
      <p className={styles.listTitle}>{title}</p>
      <ul className={styles.list}>
        {Object.values(listMessages[type]).map((text, idx) => renderListItem(text, idx))}
      </ul>
    </div>
  );
}
